import React from 'react'

const Primed = () => {
    return (
        <div className='container'>
            <h1>C++ Program to check Prime Number</h1>
            <p>Given a positive integer, check if the number is prime or not. A prime is a natural number greater than 1 
                that has no positive divisors other than 1 and itself</p>
                <p>Examples:</p>
                <div className='output'>
                Input:  n = 11 <br />
Output: true <br />
<br />
Input:  n = 15 <br />
Output: false <br />
<br />
Input:  n = 1 <br />
Output: false <br />
                    </div>        
                    <div className='containers'>
                    <div class="library"> #include&lt;iostream&gt;</div> <br/>
                    <div class="keywords">  Using namespace std; </div> <br />
 <br/>
    int <span class="token function">main</span><span class="plain">(</span><span class="plain">)</span> <br/>
     
    <span class="plain">&#123;</span> <br/>
        int no<span class="plain">,</span> i<span class="plain">;</span> <br/>
        cout<span class="plain">&lt;</span><span class="plain">&lt;</span><span class="token string">"Enter a number to be checked (greater than 2) : "</span><span class="plain">;</span> <br/>
        cin<span class="plain">&gt;</span><span class="plain">&gt;</span>no<span class="plain">;</span> <br/>
        <span class="library">for</span><span class="plain">(</span>i<span class="plain">=</span><span class="token number">2</span><span class="plain">;</span>i<span class="plain">&lt;</span>no<span class="plain">;</span>i<span class="plain">++</span><span class="plain">)</span> <br/>
        <span class="plain">&#123;</span> <br/>
            <span class="keywords">if</span><span class="plain">(</span>no<span class="plain">%</span>i<span class="plain">==</span><span class="token number">0</span><span class="plain">)</span> <br/>
            <span class="plain">&#123;</span> <br/>
                <span class="library">break</span><span class="plain">;</span> <br/>
            <span class="plain">&#125;</span> <br/>
        <span class="plain">&#125;</span> <br/>
        <span class="keywords">if</span><span class="plain">(</span>no<span class="plain">==</span>i<span class="plain">)</span> <br/>
        <span class="plain">&#123;</span> <br/>
            cout<span class="plain">&lt;</span><span class="plain">&lt;</span><span class="token string">"\n"</span><span class="plain">&lt;</span><span class="plain">&lt;</span>no<span class="plain">&lt;</span><span class="plain">&lt;</span><span class="token string">" is a prime number"</span><span class="plain">;</span> <br/>
        <span class="plain">&#125;</span> <br/>
        <span class="library">else</span> <br/>
        <span class="plain">&#123;</span> <br/>
            cout<span class="plain">&lt;</span><span class="plain">&lt;</span><span class="token string">"\n"</span><span class="plain">&lt;</span><span class="plain">&lt;</span>no<span class="plain">&lt;</span><span class="plain">&lt;</span><span class="token string">" is not a prime number"</span><span class="plain">;</span> <br/> <br/>
        <span class="plain">&#125;</span> <br/>
        return 0; <br />
    <span class="plain">&#125;</span> <br/>
   
      <br/>
                    </div>
                    <div className='output'>
                      <h3><p>Output:</p></h3>
                      <p>Enter a number to be checked (greater than 2) : </p>
                      7 <br /> <br />
                      7 is a prime number <br />
                    </div>
        </div>
    )
}

export default Primed
